import { useFragment } from '@apollo/client/react';

import { getMemberIdWithFallback } from '@trello/authentication';
import { useUserAge } from '@trello/business-logic-react/member';

import { NewUserFragmentDoc } from './NewUserFragment.generated';
import type { RuntimeEligibilityCheckResult } from './RuntimeEligibilityCheck';

export const useIsNewUser = (): RuntimeEligibilityCheckResult => {
  const userAge = useUserAge();
  const memberId = getMemberIdWithFallback();

  const { data, complete } = useFragment({
    fragment: NewUserFragmentDoc,
    fragmentName: 'NewUser',
    from: {
      id: memberId,
      __typename: 'Member',
    },
  });

  // The codegen fragment hook returned `undefined` until the read was
  // complete; this gate preserves that and may be removable later.
  const memberData = complete ? data : undefined;

  const campaigns = memberData?.campaigns ?? [];
  const newUserOnboardingCampaign = campaigns?.find(
    (c: { name: string }) => c.name === 'moonshot' || c.name === 'splitscreen',
  );
  const wentThroughNewUserOnboarding =
    newUserOnboardingCampaign?.dateDismissed !== undefined &&
    newUserOnboardingCampaign.dateDismissed !== null;

  const isNewUser = userAge < 7;

  return {
    isEligible: wentThroughNewUserOnboarding && isNewUser,
  };
};
